/**
 * @generated SignedSource<<fe2fd167a3783d2b1b1ffa71c0dff620>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserMultiSelectorQuery$variables = {
  exclude?: ReadonlyArray<string | null> | null;
  excludeAncestryFor?: string | null;
  excludeManagedUsers?: boolean | null;
  isGuests?: boolean | null;
  ranked?: boolean | null;
  search?: string | null;
};
export type UserMultiSelectorQuery$data = {
  readonly viewer: {
    readonly selectUsers: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly email: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly internalAttributes: {
            readonly manager: {
              readonly fullName: string;
              readonly id: string;
            } | null;
          } | null;
          readonly isGuest: boolean;
        };
      }>;
    } | null;
  };
};
export type UserMultiSelectorQuery = {
  response: UserMultiSelectorQuery$data;
  variables: UserMultiSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "exclude"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeAncestryFor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeManagedUsers"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGuests"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ranked"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v6 = [
  {
    "kind": "Variable",
    "name": "exclude",
    "variableName": "exclude"
  },
  {
    "kind": "Variable",
    "name": "excludeAncestryFor",
    "variableName": "excludeAncestryFor"
  },
  {
    "kind": "Variable",
    "name": "excludeManagedUsers",
    "variableName": "excludeManagedUsers"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Variable",
    "name": "isGuests",
    "variableName": "isGuests"
  },
  {
    "kind": "Variable",
    "name": "ranked",
    "variableName": "ranked"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "manager",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserMultiSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "selectUsers",
            "args": (v6/*: any*/),
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "users",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInternalAttributes",
                        "kind": "LinkedField",
                        "name": "internalAttributes",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserMultiSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "selectUsers",
            "args": (v6/*: any*/),
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "users",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInternalAttributes",
                        "kind": "LinkedField",
                        "name": "internalAttributes",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5a7ec82aac465508235e7ca09c35dca8",
    "id": null,
    "metadata": {},
    "name": "UserMultiSelectorQuery",
    "operationKind": "query",
    "text": "query UserMultiSelectorQuery(\n  $search: String\n  $isGuests: Boolean\n  $ranked: Boolean\n  $exclude: [ID]\n  $excludeAncestryFor: ID\n  $excludeManagedUsers: Boolean\n) {\n  viewer {\n    selectUsers: users(first: 25, search: $search, isGuests: $isGuests, ranked: $ranked, exclude: $exclude, excludeAncestryFor: $excludeAncestryFor, excludeManagedUsers: $excludeManagedUsers) {\n      edges {\n        node {\n          id\n          email\n          fullName\n          isGuest\n          image\n          internalAttributes {\n            manager {\n              id\n              fullName\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f08335ae801c9aa1605fcee1720215d";

export default node;
